import { __rest } from "tslib";
import * as React from 'react';
import { getOUIAProps } from '../../helpers';
export var TabButton = function TabButton(_a) {
  var children = _a.children,
      tabContentRef = _a.tabContentRef,
      ouiaId = _a.ouiaId,
      ouiaSafe = _a.ouiaSafe,
      props = __rest(_a, ["children", "tabContentRef", "ouiaId", "ouiaSafe"]);

  var Component = props.href ? 'a' : 'button';
  return React.createElement(Component, Object.assign({}, getOUIAProps(TabButton.displayName, ouiaId, ouiaSafe), props), children);
};
TabButton.displayName = 'TabButton';